import { render, staticRenderFns } from "./SampleSwatchesDialog.vue?vue&type=template&id=57dfc09b&"
import script from "./SampleSwatchesDialog.vue?vue&type=script&lang=js&"
export * from "./SampleSwatchesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SampleSwatchesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VIcon,VImg})
